import * as PropTypes from 'prop-types';

export const pointType = PropTypes.arrayOf(PropTypes.number);
